import { theme } from '../../../theme';

export const BASE_BUTTON_HEIGHTS = {
    sm: 24,
    md: 34,
    lg: 42,
} as const;

export const BASE_BUTTON_COLORS = {
    primary: theme.colors.grey1250,
    secondary: theme.colors.grey300,
    tertiary: theme.colors.grey300,
} as const;

export const BASE_BUTTON_DISABLED_COLORS = {
    primary: theme.colors.grey1250,
    secondary: theme.colors.grey1000,
    tertiary: theme.colors.grey1000,
} as const;
